// extracted by mini-css-extract-plugin
export var cardImage = "entry-card-module--card-image--48e17";
export var cardLink = "entry-card-module--card-link--119a9";
export var cardTitle = "entry-card-module--card-title--88b6d";
export var cardWrapper = "entry-card-module--card-wrapper--6a23f";
export var dark = "entry-card-module--dark--3edb7";
export var light = "entry-card-module--light--08caf";